import { ResourceCenterStrings } from "./resource-center-strings.js";
import { htmlEncode } from "./resource-center-sanitize.js";

const languageValues = {
  chinese: "zh-TW",
  japanese: "ja",
  swedish: "sv"
}

export class ResourceCenterPageUrlService {
  constructor() {
  }

  getCurrentQueryParams() {
    const queryParams = new URLSearchParams(window.location.search);

    return queryParams;
  }

  getPageNumber() {
    const queryParams = this.getCurrentQueryParams();

    let pageNumber = 1;

    if (queryParams.has(ResourceCenterStrings.pageKeyName)) {
      pageNumber = Number(queryParams.get(ResourceCenterStrings.pageKeyName))
    }

    return pageNumber;

  }

  getResourcesLanguage() {
    const urlQueryString = this.getCurrentQueryParams();
    let resourceLanguage = urlQueryString.get(ResourceCenterStrings.languageKeyName);
    if (resourceLanguage == null) {
      resourceLanguage = this.getPageLanguage();
    }

    return resourceLanguage;
  }

  getPageLanguage() {
    let languageFromPath = window.location.pathname.split('/').filter(function (el) { return el != ""; })[0];
    if (languageFromPath == "jp") { languageFromPath = languageValues.japanese; }
    if (languageFromPath == "tw") { languageFromPath = languageValues.chinese; }
    if (languageFromPath == "se") { languageFromPath = languageValues.swedish; }

    let defaultLanguage = 'en';
    const languageInputField = document.getElementById(languageFromPath);

    if (languageInputField) {
      defaultLanguage = languageInputField.id;
    }

    return defaultLanguage;
  }

  transformSelectionsToQueryParams(page, shouldPushState, currentFilterSelection) {
    const queryParams = this.parseFilterSelectionToQueryParams(page, currentFilterSelection);
    let url = new URL(window.location);
    url.search = queryParams;

    if (shouldPushState) {
      ResourceCenterPageUrlService.push(url);
    }
  }

  parseFilterSelectionToQueryParams(page, currentFilterSelection) {
    let query = new URLSearchParams();
    if (Object.keys(currentFilterSelection.selectedTaxonomies).length > 0) {
      currentFilterSelection.selectedTaxonomies.forEach(taxonomies => {
        for (const taxon in taxonomies) {
          taxonomies[taxon].taxa.forEach(taxa => {
            const taxaDomElementById = document.querySelector(`[data-id*="${taxa}"]`);
            if (taxaDomElementById) {
              const queryParamAlreadyExists = query.get(taxon) === taxaDomElementById.dataset.name
              if (!queryParamAlreadyExists) {
                query.append(taxon.toLowerCase(), taxaDomElementById.dataset.name);
              }
            }
          });
        }
      });
    }

    if(page > 0){
      query.append(ResourceCenterStrings.pageKeyName, page);
    }

    if (currentFilterSelection.searchTerm.length > 0) {
      query.append(ResourceCenterStrings.searchtextKeyName, htmlEncode(currentFilterSelection.searchTerm));
    }
    if (currentFilterSelection.language) {
      query.append(ResourceCenterStrings.languageKeyName, currentFilterSelection.language);
    }

    // Dispach event in order to be able to extend with custom filters query params
    let urlSearchParamsWrapper = {
      urlSearchParams: query
    };
    const onParseFilterToQueryParamsCompleted = new CustomEvent("onParseFilterToQueryParamsCompleted", { detail: urlSearchParamsWrapper });
    document.dispatchEvent(onParseFilterToQueryParamsCompleted);

    return query.toString();
  }

  static push(url) {
    if (!ResourceCenterPageUrlService.validate(url)) {
      throw new Error('Please provide valid URL');
    }

    let newUrl = url.search;
    if(!newUrl){
      newUrl = (!url.hash) ? url.pathname : (url.pathname + url.hash);
    }

    window.history.pushState(null, null, newUrl);
  }

  static validate(url) {
    let result = false;

    try {
      new URL(url);
      result = true;
    }
    catch (error) {
      result = false;
    }

    return result;
  }
}
